import { useCallback } from "react";
import { ColumnInstance } from "react-table";
import { SimpleSelect } from "../../form/fields/SimpleSelect";
import { FilterOperatorEnum, GraphQLTableColumn } from "../../GraphQL";

const values = [ true, false ];
export const defaultToLabel = (v: boolean) => v ? "Yes" : "No";

export function BooleanColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T> & {
  toLabel?: (v: boolean) => string
}): GraphQLTableColumn<T> {
  const currentToLabel = params?.toLabel || defaultToLabel;

  return {
    minWidth: 135,
    width: 135,
    Header: "Boolean",
    filterOperator: FilterOperatorEnum.Equal,
    Cell: ({ value, bodyCellProps }: any) => <span title={currentToLabel(value)} {...bodyCellProps}>{currentToLabel(value)}</span>,
    Filter: ({ column }: { column: ColumnInstance }) =>
      <SimpleSelect
        options={values}
        value={column.filterValue}
        onChange={column.setFilter}
        setOptionLabel={useCallback((option: boolean) => currentToLabel(option), [])}
        placeholder="Choose..."
        isClearable
        disabled={params?.filterInputDisabled}
      />,
    ...params,
    excelProps: {
      valueModifier: currentToLabel,
      filterButton: true,
      ...params?.excelProps,
    },
  };
}

export default BooleanColumnTemplate;
